<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }" [formGroup]="userForm">
    <ng-template #loading>
      <mat-spinner [diameter]="30"></mat-spinner>
    </ng-template>
    <ng-container *ngIf="mode === 'new' || (mode === 'edit' && this.user); else loading">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs>
          <h2 class="!mb-0" *ngIf="mode === 'new'">Invite a new user</h2>
          <h2 class="!mb-0" *ngIf="mode === 'edit'">{{ this.user.name }}</h2>
        </sbnb-page-header>
        <ng-container>
          <h2 *ngIf="mode === 'new'">Invite a new user</h2>
          <h2 *ngIf="mode === 'edit'">{{ this.user.name }}</h2>
        </ng-container>
      </app-feature-flag-tabs>

      <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'settings-user-management-invite'"></sbnb-helptext-wrapper>

      <div class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3 class="not-clickable" fxLayoutAlign="start center" fxLayoutGap="12px">
            <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span>User details</span>
            <span class="card__collapsed-helper-text">Personal details of the user.</span>
          </h3>
        </div>

        <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
          <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">First name</strong>
          <div fxFlex="300px" fxFlex.lt-md="none">
            <mat-form-field class="input__mini fw">
              <input
                matInput
                formControlName="first_name"
                [matAutocomplete]="auto"
                autocomplete="off"
                [matAutocompleteDisabled]="mode !== 'new'" />
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="autoCompleteSelected($event)">
                <mat-optgroup *ngIf="(filteredTeam | async).length > 0" label="Invite an existing teammate (Optional)">
                  <mat-option *ngFor="let member of filteredTeam | async" [value]="member">
                    <span>{{ member.name }}</span>
                    |
                    <small>{{ member.email }}</small>
                  </mat-option>
                </mat-optgroup>
              </mat-autocomplete>
              <mat-error *ngIf="userForm.get('first_name').hasError('required')">First name is required</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
          <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Last name</strong>
          <div fxFlex="300px" fxFlex.lt-md="none">
            <mat-form-field class="input__mini fw">
              <input matInput formControlName="last_name" />
              <mat-error *ngIf="userForm.get('last_name').hasError('required')">Last name is required</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
          <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Email</strong>
          <div fxFlex="300px" fxFlex.lt-md="none">
            <mat-form-field class="input__mini fw">
              <input matInput formControlName="email" />
              <mat-error *ngIf="userForm.get('email').hasError('required')">Email address is required</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout fxLayoutAlign="start top" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
          <strong class="profile__label" fxFlex="170px" fxFlex.lt-md="none">Access</strong>

          <div fxLayout fxLayoutGap="28px" fxLayout.lt-md="column">
            <sbnb-radio-card
              [selected]="this.userForm.get('permission_type').value === 'all'"
              (click)="this.userForm.get('permission_type').setValue('all')">
              <h4 class="mb-4 text-night">Full access</h4>
              <div fxLayout fxLayoutGap="12px" fxLayoutAlign="start center" class="permission__item">
                <ng-template [ngTemplateOutlet]="allImage"></ng-template>
                <span>Full access to all features.</span>
              </div>
              <div fxLayout fxLayoutGap="12px" class="permission__item">
                <ng-template [ngTemplateOutlet]="allImage"></ng-template>
                <span>Full access to all properties.</span>
              </div>
              <div fxLayout fxLayoutGap="12px" class="permission__item">
                <ng-template [ngTemplateOutlet]="allImage"></ng-template>
                <span>Can view financial data.</span>
              </div>
              <div fxLayout fxLayoutGap="12px" class="permission__item">
                <ng-template [ngTemplateOutlet]="notAllowedImage"></ng-template>
                <span>Can not view subscription details.</span>
              </div>
              <div fxLayout fxLayoutGap="12px" class="permission__item">
                <ng-template [ngTemplateOutlet]="notAllowedImage"></ng-template>
                <span>Can not invite new users.</span>
              </div>
            </sbnb-radio-card>
            <sbnb-radio-card
              [selected]="this.userForm.get('permission_type').value === 'custom'"
              (click)="this.userForm.get('permission_type').setValue('custom')">
              <h4 class="mb-4 text-night">Custom access</h4>
              <div fxLayout fxLayoutGap="12px" fxLayoutAlign="start center" class="permission__item">
                <ng-template [ngTemplateOutlet]="customImage"></ng-template>
                <span>Access to selected features.</span>
              </div>
              <div fxLayout fxLayoutGap="12px" class="permission__item">
                <ng-template [ngTemplateOutlet]="customImage"></ng-template>
                <span>Access to selected properties.</span>
              </div>
              <div fxLayout fxLayoutGap="12px" class="permission__item">
                <ng-template [ngTemplateOutlet]="customImage"></ng-template>
                <span>Optional access to financial data.</span>
              </div>
              <div fxLayout fxLayoutGap="12px" class="permission__item">
                <ng-template [ngTemplateOutlet]="notAllowedImageInverted"></ng-template>
                <span>Can not view subscription details.</span>
              </div>
              <div fxLayout fxLayoutGap="12px" class="permission__item">
                <ng-template [ngTemplateOutlet]="notAllowedImageInverted"></ng-template>
                <span>Can not invite new users.</span>
              </div>
            </sbnb-radio-card>
          </div>
        </div>
      </div>

      <div class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3
            class="not-clickable"
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            style="margin-top: 0; margin-bottom: 0; padding-right: 40px">
            <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span>Permissions</span>
            <span class="card__collapsed-helper-text">Select accessible features and properties for this user.</span>
          </h3>
        </div>

        <div
          fxLayout
          fxLayoutGap="24px"
          fxLayout.lt-md="column"
          [class.um__disabled]="this.userForm.get('permission_type').value !== 'custom'">
          <div fxFlex class="features__container">
            <sbnb-user-management-features-selector
              [userPermissions]="user.permissions"
              (permissionsChanged)="permissionsChanged($event)"></sbnb-user-management-features-selector>
          </div>
          <div fxFlex class="features__container">
            <sbnb-property-selection
              [allProperties]="user.all_properties"
              [selectedProperties]="user.property_ids"
              [hideChildProperties]="true"
              [listHeight]="680"
              (propertiesChange)="propertiesChanged($event)"></sbnb-property-selection>
          </div>
        </div>
      </div>

      <div class="rule__section-container" fxLayoutAlign="start center" fxLayoutGap="24px">
        <div *ngIf="mode === 'edit'">
          <button
            class="button__small button__text raspberry-darker"
            [disabled]="deleting"
            mat-flat-button
            (click)="deleteUserClicked()">
            <mat-spinner *ngIf="deleting" class="button__spinner" [diameter]="16"></mat-spinner>
            <div fxLayoutGap="8px" fxLayoutAlign="start center">
              <img src="/assets/iconography/delete.svg" />
              <span>Delete user</span>
            </div>
          </button>
        </div>
        <span fxFlex></span>
        <button fxFlex="146px" mat-flat-button class="button__secondary button__small">
          <a [routerLink]="['/settings/user-management']">Cancel</a>
        </button>
        <button
          [disabled]="saving || !userForm.valid"
          fxFlex="146px"
          mat-flat-button
          class="button__small"
          (click)="inviteClicked()">
          <mat-spinner *ngIf="saving" class="button__spinner" [diameter]="16"></mat-spinner>
          <span *ngIf="mode === 'new'">Invite</span>
          <span *ngIf="mode === 'edit'">Update</span>
        </button>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>

<ng-template #allImage>
  <sbnb-icon
    icon="check"
    [ngClass]="{
      'text-grass-darker': this.userForm.get('permission_type').value === 'all',
      'text-smoke-darker': this.userForm.get('permission_type').value !== 'all'
    }"></sbnb-icon>
</ng-template>

<ng-template #notAllowedImage>
  <sbnb-icon
    icon="not-allowed"
    [ngClass]="{
      'text-rose-darker': this.userForm.get('permission_type').value === 'all',
      'text-smoke-darker': this.userForm.get('permission_type').value !== 'all'
    }"></sbnb-icon>
</ng-template>

<ng-template #notAllowedImageInverted>
  <sbnb-icon
    icon="not-allowed"
    [ngClass]="{
      'text-rose-darker': this.userForm.get('permission_type').value !== 'all',
      'text-smoke-darker': this.userForm.get('permission_type').value === 'all'
    }"></sbnb-icon>
</ng-template>
<ng-template #customImage>
  <sbnb-icon
    icon="cog"
    [ngClass]="{
      'text-grass-darker': this.userForm.get('permission_type').value === 'custom',
      'text-smoke-darker': this.userForm.get('permission_type').value !== 'custom'
    }"></sbnb-icon>
</ng-template>
